const NE_POOLING_LABELS_TIMEOUT = 60000;
const NE_POOLING_LABELS_INTERVAL = 5000;

const NE_POOLING_LABELS_SEARCH_PROCESS_TIMEOUT = 45000;
const NE_POOLING_LABELS_SEARCH_PROCESS_INTERVAL = 5000;

export {
  NE_POOLING_LABELS_TIMEOUT,
  NE_POOLING_LABELS_INTERVAL,
  NE_POOLING_LABELS_SEARCH_PROCESS_TIMEOUT,
  NE_POOLING_LABELS_SEARCH_PROCESS_INTERVAL,
};
